import { useLocation } from "react-router-dom";

export const useScope = () => {
  const location = useLocation();

  if (location.pathname.includes("/admin")) {
    return "admin";
  }
  if (location.pathname.includes("/company")) {
    return "user";
  }
  if (location.pathname.includes("/organization")) {
    return "organization";
  }

  return "user";
};
